// A faint generated atmosphere behind a dashboard card.
//
// Deliberately understated. The same artwork sits under both the dawn and the dark theme, and the
// text colour flips between them, so anything with real contrast would fail one of the two. It is
// masked toward the top-right so it never builds up behind the stat or the label.

import archetype from '../assets/cards/card-archetype.webp';
import dreams from '../assets/cards/card-dreams.webp';
import rhythm from '../assets/cards/card-rhythm.webp';
import insight from '../assets/cards/card-insight.webp';

export type CardArtVariant = 'archetype' | 'dreams' | 'rhythm' | 'insight';

// Kept partial on purpose: a variant without artwork should render plain rather than break, which is
// what lets a card declare its art slot before the asset exists.
const ART: Partial<Record<CardArtVariant, string>> = { archetype, dreams, rhythm, insight };

export function CardArt({ variant }: { variant: CardArtVariant }) {
  const url = ART[variant];
  if (!url) return null;

  return (
    <div
      className={`ocard-art art-${variant}`}
      aria-hidden="true"
      style={{ backgroundImage: `url(${url})` }}
    />
  );
}
